import { ReactElement } from "react";

import { ReactComponent as JwLogo } from "../../../icons/justworks-logo-white-text.svg";

import styles from "./artwork.module.css";

const Artwork = (): ReactElement => {
  return (
    <div className={styles.container}>
      <div className={styles.welcomeMessage}>
        <div>Welcome to</div>
        <JwLogo />
      </div>
    </div>
  );
};

export default Artwork;
